import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useParams, useNavigate } from "react-router-dom";
import priceListActions from "../../../store/actions/items/prices/price.actions";
import { SkeletonForm } from "../../../components/general/skeleton";
import useDelayedFlag from "../../../hooks/useDelayedFlag";

export const EditPriceListPageComponent = ({ priceListActions }) => {
  const { priceListId } = useParams(); // Get price list ID from the URL
  const navigate = useNavigate();

  const [priceList, setPriceList] = useState({ name: "" }); // State to store price list details
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const showSkeleton = useDelayedFlag(isLoading);

  // Fetch price list details when the page loads
  useEffect(() => {
    fetchPriceListDetails();
  }, [priceListId]);

  const fetchPriceListDetails = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await priceListActions.getPriceLists({ pageNumber: 1, pageSize: 100 }); // Assuming it fetches all price lists
      const foundPriceList = response.payload.items.find((pl) => pl.id === priceListId);

      if (!foundPriceList) {
        alert("Price list not found.");
        navigate("/priceLists");
      } else {
        setPriceList(foundPriceList);
      }
    } catch (error) {
      console.error("Error fetching price list details:", error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPriceList({ ...priceList, [name]: value });
  };

  const handleUpdatePriceList = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      await priceListActions.updatePriceList({ id: priceListId, name: priceList.name });
      alert("Price list updated successfully!");
      navigate("/priceLists"); // Redirect back to the price list page
    } catch (error) {
      console.error("Error updating price list:", error);
      alert("Failed to update price list.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/priceLists"); // Navigate back to the price lists page
  };

  return (
    <div>
      <h2>Edit Price List</h2>

      {isLoading ? (
        showSkeleton && <SkeletonForm fields={2} />
      ) : error ? (
        <p>Error: {error.message || "Something went wrong"}</p>
      ) : (
        <form onSubmit={handleUpdatePriceList}>
          <div>
            <label>Price List Name:</label>
            <input type="text" name="name" value={priceList.name} onChange={handleInputChange} required />
          </div>
          <div>
            <button type="submit">Update</button>
            <button type="button" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    priceListActions: bindActionCreators(priceListActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(EditPriceListPageComponent);
